import AuthItem from "./auth-item.jsx"

export default {
    AuthItem
}
